'use client'

import { Container } from 'react-bootstrap'
import QuestionForm from '@/features/questions-page/Form/index.js'
import Questions from '@/features/questions-page/Questions/index.js'
import { Helmet } from 'react-helmet'

export const QuestionsPage = () => {
    return (
        <Container className={'QuestionsPage'}>
            <Helmet>
                <title>Вопрос-ответ</title>
            </Helmet>
            <h1>Вопрос-ответ</h1>
            <div className={'content-wrapper'}>
                <QuestionForm />
                <Questions />
            </div>
        </Container>
    )
}
